<script setup lang="ts">
import type { PropType } from "vue";
import type { Collection } from "~/types";
import useFavorites from "~/composables/useFavorites";
import useNotifications from "~/composables/useNotifications";

const props = defineProps({
  collection: {
    type: Object as PropType<Collection>,
    required: true,
  },
});

const {
  favoriteVisible,
  favoriteTooltip,
  favoriteIcon,
  toggleFavorites,
  isFavoriteLoading,
} = useFavorites(props.collection);

const {
  notificationsVisible,
  notificationsTooltip,
  notificationsIcon,
  toggleNotifications,
  isNotificationsLoading,
} = useNotifications(props.collection);

const length = computed(() => {
  if (props.collection?.collection_collection?.length) {
    return props.collection?.seasons;
  }
  return props.collection?.collection_video?.length;
});

const lengthTitle = computed(() => {
  if (props.collection?.collection_collection?.length) {
    return "Seasons";
  }
  return "Episodes";
});
</script>

<template>
  <div class="bg-surface-bg">
    <div class="relative">
      <img
        :src="
          getThumbnailImage([
            collection?.images || [],
            collection?.pre_air_images || [],
          ])
        "
        alt="main thumbnail"
        class="aspect-video w-full rounded-lg"
      />
      <div
        class="absolute inset-0 bg-gradient-to-t from-surface-bg to-transparent"
      />
    </div>
    <div class="relative px-5 lg:-mt-32 lg:px-10">
      <div class="mb-5 flex gap-5">
        <PgIcon
          v-if="notificationsVisible"
          v-tooltip="notificationsTooltip"
          :icon="notificationsIcon"
          :loading="isNotificationsLoading"
          @click="toggleNotifications"
        />
        <PgIcon
          v-if="favoriteVisible"
          v-tooltip="favoriteTooltip"
          :icon="favoriteIcon"
          :loading="isFavoriteLoading"
          @click="toggleFavorites"
        />
      </div>
      <div class="text-semibold text-sm lg:text-lg">
        {{ collection.description }}
      </div>
      <div v-if="length" class="text-semibold mt-4 text-lg">
        {{ lengthTitle }}: {{ length }}
      </div>
    </div>
  </div>
</template>

<style scoped></style>
